import { CompanyPermissionCode } from "@odata/GeneratedEnums";

export type Brand<T, TBrand extends string> = T & { readonly __brand: TBrand };

// Sub-sety jako const objekty – hodnoty jsou přímo z generovaného enumu
export type UserPermissionCode = Brand<
    | CompanyPermissionCode.Asset
    | CompanyPermissionCode.Audit
    | CompanyPermissionCode.Bank
    | CompanyPermissionCode.CanImport
    | CompanyPermissionCode.CashBox
    | CompanyPermissionCode.CustomerPortal
    | CompanyPermissionCode.DataBox
    | CompanyPermissionCode.DocumentPosting
    | CompanyPermissionCode.FiscalYearClose
    | CompanyPermissionCode.ChatTakeover
    | CompanyPermissionCode.InBox
    | CompanyPermissionCode.InternalDocuments
    | CompanyPermissionCode.InvoicesIssued
    | CompanyPermissionCode.InvoicesReceived
    | CompanyPermissionCode.MasterData
    | CompanyPermissionCode.PrPayroll
    | CompanyPermissionCode.PrPayrollSetting
    | CompanyPermissionCode.ReceivableAdjustments
    | CompanyPermissionCode.RecurringTask
    | CompanyPermissionCode.Reports
    | CompanyPermissionCode.VatStatement,
    "UserPermissionCode"
>;

export type CustomerPermissionCode = Brand<
    | CompanyPermissionCode.PrAttendance
    | CompanyPermissionCode.CompanyInfo
    | CompanyPermissionCode.AccountingReports
    | CompanyPermissionCode.PrPayrollAgenda
    | CompanyPermissionCode.DocumentApproval
    | CompanyPermissionCode.PrPayrollInfoConfidential
    | CompanyPermissionCode.Payments
    | CompanyPermissionCode.PrPayrollInfo
    | CompanyPermissionCode.ChatInteractWithAccountant,
    "CustomerPermissionCode"
>;

export const UserPermissionCodes = {
    Asset: CompanyPermissionCode.Asset as UserPermissionCode,
    Audit: CompanyPermissionCode.Audit as UserPermissionCode,
    Bank: CompanyPermissionCode.Bank as UserPermissionCode,
    CanImport: CompanyPermissionCode.CanImport as UserPermissionCode,
    CashBox: CompanyPermissionCode.CashBox as UserPermissionCode,
    CustomerPortal: CompanyPermissionCode.CustomerPortal as UserPermissionCode,
    DataBox: CompanyPermissionCode.DataBox as UserPermissionCode,
    DocumentPosting: CompanyPermissionCode.DocumentPosting as UserPermissionCode,
    FiscalYearClose: CompanyPermissionCode.FiscalYearClose as UserPermissionCode,
    ChatTakeover: CompanyPermissionCode.ChatTakeover as UserPermissionCode,
    InBox: CompanyPermissionCode.InBox as UserPermissionCode,
    InternalDocuments: CompanyPermissionCode.InternalDocuments as UserPermissionCode,
    InvoicesIssued: CompanyPermissionCode.InvoicesIssued as UserPermissionCode,
    InvoicesReceived: CompanyPermissionCode.InvoicesReceived as UserPermissionCode,
    MasterData: CompanyPermissionCode.MasterData as UserPermissionCode,
    PrPayroll: CompanyPermissionCode.PrPayroll as UserPermissionCode,
    PrPayrollSetting: CompanyPermissionCode.PrPayrollSetting as UserPermissionCode,
    ReceivableAdjustments: CompanyPermissionCode.ReceivableAdjustments as UserPermissionCode,
    RecurringTask: CompanyPermissionCode.RecurringTask as UserPermissionCode,
    Reports: CompanyPermissionCode.Reports as UserPermissionCode,
    VatStatement: CompanyPermissionCode.VatStatement as UserPermissionCode,
} as const;

export const CustomerPermissionCodes = {
    PrAttendance: CompanyPermissionCode.PrAttendance as CustomerPermissionCode,
    CompanyInfo: CompanyPermissionCode.CompanyInfo as CustomerPermissionCode,
    AccountingReports: CompanyPermissionCode.AccountingReports as CustomerPermissionCode,
    PrPayrollAgenda: CompanyPermissionCode.PrPayrollAgenda as CustomerPermissionCode,
    DocumentApproval: CompanyPermissionCode.DocumentApproval as CustomerPermissionCode,
    PrPayrollInfoConfidential: CompanyPermissionCode.PrPayrollInfoConfidential as CustomerPermissionCode,
    Payments: CompanyPermissionCode.Payments as CustomerPermissionCode,
    PrPayrollInfo: CompanyPermissionCode.PrPayrollInfo as CustomerPermissionCode,
    ChatInteractWithAccountant: CompanyPermissionCode.ChatInteractWithAccountant as CustomerPermissionCode,
} as const;
